"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixDates = void 0;
const firebase_1 = require("firebase");
function fixDates(user) {
    if (user) {
        if (user.createdAt)
            user.createdAt = timestampToDate(user.createdAt);
        if (user.updatedAt)
            user.updatedAt = timestampToDate(user.updatedAt);
    }
}
exports.fixDates = fixDates;
function timestampToDate(input) {
    console.log(input);
    if (isFirebaseTimestamp(input)) {
        console.log("Is Firebase Timestamp");
        let timestamp = new firebase_1.firestore.Timestamp(input._seconds, input._nanoseconds);
        if (timestamp) {
            console.log("Is converted to: " + timestamp.toDate());
            return timestamp.toDate();
        }
    }
    return undefined;
}
function isFirebaseTimestamp(input) {
    return input._seconds !== undefined;
}
//# sourceMappingURL=helpers.js.map